module.exports = __webpack_public_path__ + "img/toscana-desktop.6fb86fa5.webp";